<footer class="landing-inversores__footer">
  <div class="landing-inversores__container landing-inversores__footer-inner">
    <landing-inversores-logo></landing-inversores-logo>
    <p class="landing-inversores__footer-copy">&copy; {{ currentYear }} Inviertis. Invierte en pisos ya alquilados.</p>
  </div>
</footer>
